/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
// Remove unused imports
// import { useStaticQuery, graphql } from "gatsby"

// import Header from "./header"
import "./layout.css"
// Re-import logo
import fishSnifferLogo from "../images/fishsnifferlogo.png"

const Layout = ({ children }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `)

  return (
    // Main container: Full height, flex column, relative for logo positioning
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position: 'relative', 
        paddingTop: 'calc(60px + var(--space-4) + var(--space-3))', // Padding to clear logo + space
        paddingBottom: 'var(--space-5)', // Space above footer
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {/* Logo positioned absolutely at top-center */}
      <img 
        src={fishSnifferLogo}
        alt="Fish Sniffer Logo"
        style={{
          position: 'absolute',
          top: 'var(--space-4)', 
          left: '50%', 
          transform: 'translateX(-50%)',
          height: "60px", 
          width: "auto",
          zIndex: 10
        }}
      />
      
      {/* Main content area: grows, centers content horizontally and vertically */}
      <main 
        style={{
          flexGrow: 1, // Takes up available vertical space
          width: '100%', // Full width
          maxWidth: `var(--size-content)`,
          margin: `0 auto`, // Horizontal centering
          // We need display: flex here so index.js height:100% works
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {children}
      </main>

      {/* Footer: Centered at the bottom */}
      <footer
        style={{
          width: '100%',
          textAlign: `center`,
          fontSize: `var(--font-sm)`,
          color: `var(--color-text)`,
          paddingTop: `var(--space-4)` // Space between main and footer
        }}
      >
        <p style={{ margin: '0 auto', fontSize: 'var(--font-sx)' }}>
          The Fish Sniffer LLC 2025
        </p>
      </footer>
    </div>
  )
}

export default Layout
